import { makeStyles, Theme } from "@material-ui/core/styles";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: Theme) => ({
  appPageContent: {
    flexDirection: "column",
    padding: "0 20px 20px"
  },
  subtitle: {
    padding: "15px 0 10px 0"
  },
  pagePaper: {
    padding: 20,
    display: "flex",
    justifyContent: "space-between"
  },
  pagePaperFlexColumn: {
    flexDirection: "column",
    overflowX: "hidden",
    [theme.breakpoints.down(Breakpoints.SX_720)]: {
      overflowX: "scroll",
      overflowY: "hidden"
    }
  },
  paperFlexTop: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "end",
    marginBottom: 20,
    "& div": {
      marginRight: 10
    },
    [theme.breakpoints.down(Breakpoints.SX_720)]: {
      flexDirection: "column",
      justifyContent: "flex-start"
    }
  },
  submitBtn: {
    marginTop: 12
  },
  paperTextFields: {
    [theme.breakpoints.down(Breakpoints.MD_960)]: {
      justifyContent: "flex-start",
      flexWrap: "wrap",
      "& div": {
        marginRight: 15
      }
    },
    "@media screen and (max-width: 750px)": {
      flexDirection: "column",
      flexWrap: "nowrap"
    }
  },
  paperFlexBottom: {
    minWidth: 730,
    overflowX: "auto"
  },
  saveBtn: {
    height: 41,
    marginTop: 7
  },
  rootHelperText: {
    width: "90%",
    display: "flex",
    flexWrap: "wrap"
  }
}));
